import React from "react";
import './style.css';


const Spinner  = (props) => {
  const { loadingLabel, isOverlay } = props;
  return (
    <div>
      {isOverlay ? <div className="custom-spinner"/> : null}
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">{loadingLabel}</span>
      </div>
    </div>
  );
};

export default Spinner;
